import { FormOutlined } from "@ant-design/icons";
import { Checkbox, Col, Row } from "antd";
import ButtonComponent from "components/button/Button";
import InputComponent from "components/formInput/Input";
import Loading from "components/loading/Loading";
import ModalConfirm from "components/popup-confirm";
import TableComponent from "components/table/Table";
import {
  apiDelPatients,
  apiExportCSVPatient,
  apiExportCSVAllPatient,
  apiGetPatients,
  apiHidePatients,
} from "helpers/api/master/patients";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import { setPatientInfo, showToastError, showToastSuccess } from "utils";
import "./styles.scss";
import moment from "moment";
import { useLocation } from 'react-router-dom';

const PatientsPage = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  let p = searchParams.get("p");

  if (!p) {
    p = 1
  }

  const [isLoading, setIsLoading] = useState(false);
  const [patients, setPatients] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [dataSearch, setDataSearch] = useState({});
  const userInfo = JSON.parse(Cookies.get("USER_INFO")) || {};
  const [filters, setFilters] = useState([]);
  const [keySearch, setKeySearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(p);
  const [totalPage, setTotalPage] = useState(1);
  const columns = [
    {
      title: "ID No.",
      align: "center",
      key: "code",
      dataIndex: "code"
    },
    {
      title: "患者名",
      align: "center",
      key: "name",
      render: (data) => {
        const name = data.first_name_clinic && data.last_name_clinic ? `${data.first_name_clinic} ${data.last_name_clinic}` : `${data.first_name} ${data.last_name}`;
        return (
          <a style={{
            textDecoration: "underline"
          }}
            onClick={() => {
              history.push(ROUTE.CLINIC.GRAPH.replace(":id", data.id))
              setPatientInfo(data);
            }}
          >
            {name}
          </a>
        )
      }
    },
    {
      title: t("生年月日"),
      dataIndex: "date_of_birth",
      align: "center",
      key: "birthday",
    },
    {
      title: "治療開始日",
      align: "center",
      key: "startDate",
      render: (data) => (
        <span>
          {data.treatment_start_date_clinic ? data.treatment_start_date_clinic : data.treatment_start_date}
        </span>
      )
    },
    {
      title: t("データ最終アップデート日時"),
      dataIndex: "last_receive_date",
      align: "center",
      key: "last_receive_date",
      render: (date) => {
        if (!date) {
          return (<span></span>)
        }

        const utcDate = new Date(date);
        const localDate = new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60 * 1000));

        return (
          <span>{moment(localDate).format("YYYY-MM-DD HH:mm:ss")}</span>
        )
      }
    },
    {
      title: t("メモ"),
      dataIndex: "memo",
      align: "center",
      key: "content",
    },
    {
      title: "",
      width: 50,
      align: "center",
      key: "action",
      dataIndex: "id",
      render: (text) => {
        return (
          <FormOutlined
            fill="#0687BB"
            onClick={() => {
              history.push(ROUTE.CLINIC.PATIENT_EDIT.replace(":id", text));
              setPatientInfo({ id: text });
            }
            }
          />
        );
      },
    },
  ];

  const addQueryParam = (key, value) => {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    window.history.pushState({}, "", `${window.location.pathname}?${params}`);
  };

  const updatePage = (newPage) => {
    addQueryParam("p", newPage)
    setPage(newPage)
  }

  useEffect(() => {
    if (!p) {
      p = 1
    }
    setPage(p);
  }, [p]);

  const getAllPatiens = () => {
    setIsLoading(true);
    apiGetPatients({ page: page, limit: 15 }).then((resp) => {
      setIsLoading(false);
      let newPatients = [];
      if (resp.data) {
        newPatients = resp.data.map((item, index) => ({
          ...item,
          key: item.id,
        }));

        setPage(resp.page);
        setTotalPage(resp.total_page);
      }

      setPatients(newPatients);
    }).catch((err) => {
      console.log(err);
    });
  }

  // get list patients
  useEffect(() => {
    setIsLoading(true);
    apiGetPatients({ ...dataSearch, page: page, limit: 15 }).then((resp) => {
      setIsLoading(false);
      let newPatients = [];
      if (resp.data) {
        newPatients = resp.data.map((item, index) => ({
          ...item,
          key: item.id,
        }));

        if (!filters.isHidden) newPatients = newPatients.filter((item) => item.hidden === false)

        setPage(resp.page);
        setTotalPage(resp.total_page);
      }

      setPatients(newPatients);
      setSelectedRowKeys([]);
    }).catch((err) => {
      console.log(err);
    });
  }, [dataSearch, page]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handlerClickHidePatients = () => {
    setIsLoading(true);
    apiHidePatients({ patient_ids: selectedRowKeys })
      .then((resp) => {
        setIsLoading(false);
        if (resp.data) {
          showToastSuccess("messages.MSG-USP089");
          handlerClickSearch();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlerClickDeletePatients = () => {
    setIsLoading(true);
    apiDelPatients({ patient_ids: selectedRowKeys }).then((resp) => {
      setIsLoading(false);
      if (resp.data) {
        showToastSuccess("messages.MSG-USP054");
        setIsModalOpen(false);
        handlerClickSearch();
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  const handlerClickExportCSV = () => {
    setIsLoading(true);
    apiExportCSVPatient({ patient_ids: selectedRowKeys })
      .then((resp) => {
        setIsLoading(false);
        if (resp.data) {
          window.location.href = resp.data;
          showToastSuccess("messages.MSG-USP024");
          setSelectedRowKeys([]);
        }
      })
      .catch((err) => {
        console.log(err);
        showToastError("messages.MSG-USP097");
      });
  };

  const handleChangeCheckbox = (e, name) => {
    if (e.target.checked) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        [name]: `${name}:true`
      }))
    } else {
      setFilters((prevFilters) => {
        delete (prevFilters[name]);
        return {
          ...prevFilters
        }
      })
    }
  };

  const handlerClickSearch = () => {
    setDataSearch({
      filter: Object.values(filters).join(","),
      key_search: keySearch
    });
  };

  const handlerClickShowAll = () => {
    setFilters((prevFilters) => {
      delete (prevFilters.isHidden);
      return {
        ...prevFilters
      }
    })
    getAllPatiens();
  };

  const handlerKeydown = (e) => {
    if (e.key === "Enter") {
      handlerClickSearch();
    }
  };

  const handlerClickExportAllPatientCSV = () => {
    setIsLoading(true);
    apiExportCSVAllPatient()
      .then((resp) => {
        setIsLoading(false);
        if (resp.data) {
          window.location.href = resp.data;
          showToastSuccess("messages.MSG-USP024");
          setSelectedRowKeys([]);
        }
      })
      .catch((err) => {
        console.log(err);
        showToastError("messages.MSG-USP097");
      });
  };

  return (
    <div className="main-content">
      <div className="root-right-header">
        <div className="screen-name">{`${userInfo.clinic_name}  様`}</div>
      </div>
      <div className="nav screen-title">患者リスト</div>

      <div className="content">
        <Container>
          <Row gutter={[24, 24]} className="patients-top-actions">
            <Col xs={24} md={7}>
              <InputComponent
                suffix={
                  <img
                    src="/icons/search_img.png"
                    className="ic x2"
                    onClick={handlerClickSearch}
                  />
                }
                placeholder="検索"
                onChange={(e) => setKeySearch(e.target.value)}
                onKeyDown={handlerKeydown}
              />
            </Col>

            <Col xs={24} md={17} className="patients-action-buttons">
              <Row gutter={[16, 16]} justify={"center"}>
                <ButtonComponent
                  background="#7ed957"
                  className="btn_block"
                  text="リストデータ出力"
                  disabled={selectedRowKeys.length === 0}
                  onClick={handlerClickExportCSV}
                />


                <ButtonComponent
                  background="#737373"
                  className="btn_block"
                  text="非表示"
                  disabled={selectedRowKeys.length === 0}
                  onClick={handlerClickHidePatients}
                />
                <ButtonComponent
                  background="#fb5757"
                  className="btn_block"
                  text="削除"
                  disabled={selectedRowKeys.length === 0}
                  onClick={() => setIsModalOpen(true)}
                />
                <div className="patients-action-links">
                  <Row gutter={[24, 24]}>
                    <Col xs={24} md={12}>
                      <a className="link" onClick={handlerClickShowAll}>
                        全件表示
                      </a>
                    </Col>

                    <Col xs={24} md={12}>
                      <a className="link" onClick={handlerClickExportAllPatientCSV}>
                        全件データ出力
                      </a></Col>
                  </Row>
                </div>
              </Row>
            </Col>
          </Row>

          <Row gutter={[16, 16]} className="patients-filters">
            <Col xs={24} md={6}>
              <Checkbox
                name="patient_name"
                checked={filters.name}
                onChange={(e) => handleChangeCheckbox(e, "name")}
              >
                <span className="text_block">患者名で検索</span>
              </Checkbox>
            </Col>
            <Col xs={24} md={6}>
              <Checkbox
                name="patient_id"
                checked={filters.id}
                onChange={(e) => handleChangeCheckbox(e, "id")}
              >
                <span className="text_block">ID No.で検索</span>
              </Checkbox>
            </Col>
            <Col xs={24} md={6}>
              <Checkbox
                name="show_hidden_patients"
                checked={filters.isHidden}
                onChange={(e) => handleChangeCheckbox(e, "isHidden")}
              >
                <span className="text_block">非表示リスト</span>
              </Checkbox>
            </Col>
          </Row>

          <TableComponent
            columns={columns}
            dataSource={patients}
            rowSelection={rowSelection}
            page={page}
            totalPage={totalPage}
            showPagination={totalPage > 1}
            onChangePage={updatePage}
            rowClassName={(record, index) =>
              record.hidden ? "table-row-black" : ""
            }
          />
        </Container>

        <ModalConfirm
          content="本当に削除しますか。"
          open={isModalOpen}
          onOkText="削除"
          onCancelText="キャンセル"
          onOkColor="red"
          onOk={handlerClickDeletePatients}
          onCancel={() => setIsModalOpen(false)}
        />
      </div>
      {isLoading && <Loading />}
    </div>
  );
};

export default PatientsPage;
